<template>
  <tr class="tr-foot-last">
    <td colspan="8">
      <button class="tab-but-doc" @click="sUploader" v-if="aDocs()">
        Загрузить документ
      </button>
      <div
        class="modal fade in show"
        v-if="showUploader"
        tabindex="-1"
        role="dialog"
      >
        <div class="window-doc" v-show="!showECP">
          <h3>ЗАГРУЗКА ДОКУМЕНТА</h3>
          <form
            action="#"
            @submit.prevent="submit"
            class="load-doc"
            style="padding-right: 20px"
          >
            <p>
              <label>Вид документа</label>
              <select
                @change="bindChange"
                v-model="typeIndex"
                class="i-style i-style-sel"
              >
                <option
                  v-for="(doc, docIndex) in aDocs()"
                  :value="docIndex"
                  :key="docIndex"
                  >{{ stripTags(doc.NAME) }}</option
                >
              </select>
            </p>
            <p v-if="typeIndex >= 0 && docs[typeIndex].IS_MULTIPLY">
              <label>Документ</label>
              <select
                @change="bindChange"
                v-if="docNames"
                v-model="docName"
                class="i-style i-style-sel"
              >
                <option v-for="v in docNames" :value="v.ID" :key="v.ID">{{
                  v.NAME
                }}</option>
              </select>
              <span v-else>Не указаны названия документов!</span>
            </p>
            <div class="file-upload" v-if="fileName">
              <div class="file-upload-label">Файл:</div>
              <button type="button">Выберите файл</button>
              <div v-text="fileName"></div>
              <input
                type="file"
                :accept="accept"
                name="file"
                ref="file"
                @change="changeFile"
              />
            </div>
            <div class="row"><span v-text="fileName2"></span></div>

            <div v-if="errorText" class="alert alert-danger">
              {{ errorText }}
            </div>
            <!-- <div v-show="typeIndex >= 0 && docs[typeIndex].IS_ECP_REQ">
              Файл требует обязательной подписи!
            </div>-->
            <div
              v-for="(err, errIndex) in errorArr"
              class="alert alert-danger"
              style="margin-top: 10px"
              :key="errIndex"
            >
              {{ err.TEXT }}
            </div>
            <div class="foot-butt center-block" style="text-align: center">
              <button type="button" class="b-o" @click="showUploader = false">
                Отмена
              </button>
              <button
                v-if="ecpAvailable && typeIndex >= 0 && !uploadAvailable"
                type="button"
                @click="startECP()"
                class="b-l"
              >
                Подписать
              </button>
              <button
                type="submit"
                :class="!uploadBlockButton ? 'b-l' : ''"
                v-show="uploadAvailable"
                :disabled="!uploadAvailable || uploadBlockButton"
              >
                Загрузить
              </button>
            </div>
          </form>
        </div>
        <div class="window-doc" v-show="showECP">
          <h3>ПОДПИСЬ ДОКУМЕНТА</h3>
          <div v-if="!ecpPluginEnabled" style="color: red;text-align: center">
            Плагин не активен
          </div>
          <div v-else style="color: green;text-align: center">
            Плагин загружен.
          </div>
          <br />
          <form action="#" @submit.prevent="submit" class="load-doc">
            <div>
              <strong>Укажите сертификат подписи</strong>
            </div>
            <select
              v-model="ecpCert"
              class="i-style i-style-sel"
              style="width: 555px"
            >
              <option
                v-for="(cert, certIndex) in ecpCerts"
                :value="cert"
                :key="certIndex"
                >{{ cert.text }}</option
              >
            </select>
            <br />
            <br />
            <div>
              <a :href="siteUrl + 'methods/doc/Инструкция_ЭЦП.pdf'"
                >Инструкция по установке ЭЦП</a
              >
              <br />КриптоПро ЭЦП Browser plug-in
              <a href="https://www.cryptopro.ru/products/cades/plugin/get_2_0"
                >скачать</a
              >
            </div>
            <div class="foot-butt center-block" style="text-align: center">
              <button type="button" class="b-o" @click="showUploader = false">
                Отмена
              </button>
              <button
                type="button"
                :disabled="ecpCert === null"
                @click="Common_SignCadesBES_File()"
                class="b-l"
              >
                Подписать
              </button>
            </div>
          </form>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
/*global cadesplugin*/
import { ProjectsService } from "@/common/api.service";
import { mapGetters } from "vuex";
import "@/scripts/cadesplugin_api";
import { AUTH_URL } from "@/common/config";

export default {
  name: "UploadRow",
  props: ["parent", "docs", "project", "documentConf", "subIndex"],
  data() {
    return {
      fileForm: {
        TYPE_ID: 0,
        file: "",
        EXPERTISE_ID: 0
      },
      errorText: "",
      showUploader: false,
      typeIndex: -1,
      docName: "",
      file: "",
      fileName: "Файл не выбран",
      fileName2: "",
      accept: "",
      showECP: false,
      ecpPluginEnabled: false,
      ecpCerts: [],
      ecpValue: "",
      ecpCert: null,
      ecpEnsurer: "",
      isLoadCert: false,
      fileBase64: "",
      siteUrl: "",
      uploadBlockButton: false,
      errorArr: []
    };
  },
  mounted() {
    this.bindChange();
    this.siteUrl = AUTH_URL;
  },
  computed: {
    docNames() {
      if (this.typeIndex < 0) {
        return false;
      }
      if (!this.docs[this.typeIndex].IS_MULTIPLY) {
        return false;
      }
      if (
        !this.documentConf.FILE_DOCUMENTS_PATH[
          this.docs[this.typeIndex].TYPE_ID
        ]
      ) {
        return false;
      }
      let docNames = [];
      this.documentConf.FILE_DOCUMENTS_PATH[
        this.docs[this.typeIndex].TYPE_ID
      ].forEach(function(docFile) {
        docNames.push({
          ID: docFile.ID,
          NAME: docFile.UF_USER_FILE_NAME,
          UF_FORMAT_REQ_FILE: docFile.UF_FORMAT_REQ_FILE
        });
      });

      return docNames;
    },
    docExts() {
      let exts = [];
      if (this.docNames) {
        this.docNames.forEach(function(d) {
          if (d.ID === this.docName) {
            d.UF_FORMAT_REQ_FILE.split(";").forEach(function(v) {
              if (v !== "") {
                exts.push(v);
              }
            });
          }
        }, this);
      }
      return exts;
    },
    uploadAvailable() {
      if (this.fileName === "Файл не выбран") {
        return false;
      }
      if (this.typeIndex < 0) {
        return false;
      }
      if (this.docs[this.typeIndex].IS_MULTIPLY && this.docName === "") {
        return false;
      }
      if (this.docs[this.typeIndex].IS_ECP_REQ && !this.ecpValue) {
        return false;
      }

      return true;
    },
    ecpAvailable() {
      if (this.typeIndex < 0) {
        return false;
      }
      if (this.docs[this.typeIndex].IS_ECP) {
        return true;
      }

      return false;
    },
    ...mapGetters(["currentUser"])
  },
  methods: {
    aDocs() {
      let rDocs = {};
      let r = false;
      if (!this.docs) {
        return r;
      }
      Object.keys(this.docs).map(function(i) {
        if (
          (this.currentUser.TYPE_USER === "declarer" &&
            this.docs[i].IS_LOAD_FILE_USER) ||
          (this.currentUser.TYPE_USER === "manager" &&
            this.docs[i].IS_LOAD_FILE_MANAGER)
        ) {
          let skip = false;
          if (
            this.currentUser.TYPE_USER === "manager" &&
            this.docs[i].IS_LOAD_FILE_MANAGER
          ) {
            skip = true;
            this.docs[i].LOAD_MANAGER_LIST.forEach(function(v) {
              if (this.currentUser.ACTIVE_ROLE_CODE === v.ACTIVE_CODE) {
                skip = false;
              }
            }, this);
          }
          if (this.documentConf.FILE_DOCUMENTS_PATH[this.docs[i].TYPE_ID]) {
            let k = this.documentConf.FILE_DOCUMENTS_PATH[this.docs[i].TYPE_ID];
            if (this.parent && this.parent.RECORD_MODEL_ID > 0) {
              k.forEach(function(el) {
                if (el.RECORD_MODEL_ID === this.parent.RECORD_MODEL_ID) {
                  if (el.UF_IS_AKCEPT > 0 && el.UF_IS_AKCEPT != 2) {
                    skip = true;
                  }
                }
              }, this);
            } else {
              if (
                k[k.length - 1].UF_IS_AKCEPT > 0 &&
                k[k.length - 1].UF_IS_AKCEPT != 2
              ) {
                skip = true;
              }
            }
          }
          if (!skip) {
            rDocs[i] = this.docs[i];
          }
          r = true;
        }
      }, this);
      if (r && Object.keys(rDocs).length) {
        return rDocs;
      }
      return false;
    },
    sUploader() {
      this.showUploader = !this.showUploader;
      this.typeIndex = -1;
      this.docName = "";
      this.file = "";
      this.fileName = "Файл не выбран";
      this.fileName2 = "";
      this.showECP = false;
      this.ecpPluginEnabled = false;
      this.ecpCerts = [];
      this.ecpValue = "";
      this.ecpEnsurer = "";
      this.isLoadCert = false;
      this.fileBase64 = "";
      this.errorArr = [];
      this.errorText = "";
      this.uploadBlockButton = false;
      console.log("aDocs(); ", JSON.parse(JSON.stringify(this.aDocs())));
      console.log("docNames(); ", JSON.parse(JSON.stringify(this.docNames)));
    },
    startECP() {
      this.showECP = true;
      this.Common_CheckForPlugIn();
    },
    Common_CheckForPlugIn() {
      cadesplugin.set_log_level(cadesplugin.LOG_LEVEL_DEBUG);
      let canAsync = !!cadesplugin.CreateObjectAsync;
      if (canAsync) {
        return this.CheckForPlugIn_Async();
      } else {
        //return CheckForPlugIn_NPAPI();
      }
    },
    CheckForPlugIn_Async() {
      this.ecpPluginEnabled = true;
      let _this = this;
      cadesplugin.async_spawn(function*() {
        //let oAbout = yield cadesplugin.CreateObjectAsync("CAdESCOM.About");
        yield _this.FillCertList_Async();
      });
    },
    updateDocInfo() {
      ProjectsService.getDocumentESProjects(this.$route.params.id).then(
        ({ data }) => {
          this.documentConf.FILE_LOAD_INFO = data.FILE_LOAD_INFO;
          this.documentConf.FILE_ACCEPT_INFO = data.FILE_ACCEPT_INFO;
          this.documentConf.FILE_DOCUMENTS_PATH = data.FILE_DOCUMENTS_PATH;
          this.documentConf.LIST_TYPE = data.LIST_TYPE;
        },
        this
      );
    },
    FillCertList_Async() {
      let _this = this;
      cadesplugin.async_spawn(function*() {
        let oStore;
        try {
          oStore = yield cadesplugin.CreateObjectAsync("CAdESCOM.Store");
          if (!oStore) {
            alert("Ошибка чтения сертификатов ЭЦП");
            return;
          }

          yield oStore.Open();
        } catch (ex) {
          alert("Ошибка чтения сертификатов ЭЦП");
        }

        let CertificatesObj = yield oStore.Certificates;

        let certCnt = yield CertificatesObj.Count;
        if (certCnt == 0) {
          throw "Сертификаты не найдены";
        }

        try {
          yield oStore.Open(cadesplugin.CADESCOM_CONTAINER_STORE);
          let certs = yield oStore.Certificates;
          let certCnt = yield certs.Count;
          for (let i = 1; i <= certCnt; i++) {
            let cert = yield certs.Item(i);

            let oOpt = {
              text: "",
              value: ""
            };
            oOpt.text = yield cert.SubjectName;
            oOpt.value = yield cert.Thumbprint;
            console.log("ceeert", oOpt);
            console.log(_this.isLoadCert);
            if (!_this.isLoadCert) {
              _this.ecpCerts.push(oOpt);
            }
          }
          yield oStore.Close();
          _this.isLoadCert = true;
        } catch (ex) {
          console.log(ex);
        }
      });
    },
    Common_SignCadesBES_File() {
      let canAsync = !!cadesplugin.CreateObjectAsync;
      if (canAsync) {
        return this.SignCadesBES_Async_File();
      } else {
        //return SignCadesBES_NPAPI_File(id);
      }
    },
    SignCadesBES_Async_File() {
      let _this = this;
      cadesplugin.async_spawn(function*() {
        try {
          //FillCertInfo_Async(certificate);
          let oSigner;
          let errormes = "";
          try {
            oSigner = yield cadesplugin.CreateObjectAsync("CAdESCOM.CPSigner");
          } catch (err) {
            errormes = "Failed to create CAdESCOM.CPSigner: " + err.number;
            throw errormes;
          }
          let oSigningTimeAttr = yield cadesplugin.CreateObjectAsync(
            "CADESCOM.CPAttribute"
          );

          let CAPICOM_AUTHENTICATED_ATTRIBUTE_SIGNING_TIME = 0;
          yield oSigningTimeAttr.propset_Name(
            CAPICOM_AUTHENTICATED_ATTRIBUTE_SIGNING_TIME
          );
          let oTimeNow = new Date();
          yield oSigningTimeAttr.propset_Value(oTimeNow);
          let attr = yield oSigner.AuthenticatedAttributes2;
          yield attr.Add(oSigningTimeAttr);

          let oDocumentNameAttr = yield cadesplugin.CreateObjectAsync(
            "CADESCOM.CPAttribute"
          );
          let CADESCOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_NAME = 1;
          yield oDocumentNameAttr.propset_Name(
            CADESCOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_NAME
          );
          yield oDocumentNameAttr.propset_Value("Document Name");
          yield attr.Add(oDocumentNameAttr);

          let oStore = yield cadesplugin.CreateObjectAsync("CAdESCOM.Store");
          try {
            oStore.Open(cadesplugin.CADESCOM_CONTAINER_STORE);
          } catch (e) {
            alert("Ошибка при открытии хранилища");
            console.log(e);
            return;
          }

          let CertificatesObj = yield oStore.Certificates;
          let CAPICOM_CERTIFICATE_FIND_SHA1_HASH = 0;
          let oCerts = yield CertificatesObj.Find(
            CAPICOM_CERTIFICATE_FIND_SHA1_HASH,
            _this.ecpCert.value
          );

          if (oCerts.Count == 0) {
            errormes = "Certs not found";
            throw errormes;
          }

          let oCert = yield oCerts.Item(1);
          let sName = yield oCert.SubjectName;

          if (oSigner) {
            yield oSigner.propset_Certificate(oCert);
          } else {
            errormes = "Failed to create CAdESCOM.CPSigner";
            throw errormes;
          }

          let oSignedData = yield cadesplugin.CreateObjectAsync(
            "CAdESCOM.CadesSignedData"
          );
          let CADES_BES = 1;
          let dataToSign = _this.fileBase64;
          if (dataToSign) {
            yield oSignedData.propset_ContentEncoding(1); //CADESCOM_BASE64_TO_BINARY
            yield oSignedData.propset_Content(dataToSign);
            yield oSigner.propset_Options(1); //CAPICOM_CERTIFICATE_INCLUDE_WHOLE_CHAIN
            try {
              _this.ecpValue = yield oSignedData.SignCades(oSigner, CADES_BES);
              _this.showECP = false;
              let sn = sName.split(",");
              sn.forEach(function(v) {
                let r = v.replace("CN=", "");
                if (r.length !== v.length) {
                  _this.ecpEnsurer = r.trim();
                }
              });
            } catch (err) {
              throw err;
            }
          }
          //alert(Signature)
        } catch (err) {
          console.log("sign err", err);
          alert(`У сертификата подписи: ${err.message}`);
        }
      });
    },
    bindChange() {
      if (this.typeIndex < 0) {
        return;
      }
      let types = this.docs[this.typeIndex].EXT_TYPE
        ? this.docs[this.typeIndex].EXT_TYPE.split(";")
        : this.docs[this.typeIndex].EXT.split(";");
      this.file = "";
      this.fileName = "Файл не выбран";
      this.ecpCert = null;
      this.ecpValue = "";
      this.errorText = "";

      this.accept = "";
      if (
        (this.docs[this.typeIndex].IS_MULTIPLY ||
          this.docs[this.typeIndex].UF_IS_MULTY) &&
        this.docs[this.typeIndex].IS_FILE_MANAGER_REQUEST
      ) {
        this.accept = "." + this.docExts.join(",.");
      } else {
        this.accept = "." + types.join(",.");
      }
    },
    submit() {
      this.uploadBlockButton = true; //блокировка кнопки
      console.log(
        "this.docs[this.typeIndex].EXPERTISE_ID: ",
        this.docs[this.typeIndex].EXPERTISE_ID
      );
      if (typeof this.$refs.file.files[0] === "undefined") {
        return false;
      }

      let formData = new FormData();
      if (this.docName > 0) {
        formData.append("ID", this.docName);
        formData.append("EXPERTISE_ID", this.docs[this.typeIndex].EXPERTISE_ID);
      } else if (
        this.documentConf.FILE_DOCUMENTS_PATH[this.docs[this.typeIndex].TYPE_ID]
      ) {
        if (this.parent && this.parent.RECORD_MODEL_ID > 0) {
          this.documentConf.FILE_DOCUMENTS_PATH[
            this.docs[this.typeIndex].TYPE_ID
          ].forEach(function(r) {
            if (r.RECORD_MODEL_ID === this.parent.RECORD_MODEL_ID) {
              formData.append("ID", r.ID);
              formData.append(
                "EXPERTISE_ID",
                this.docs[this.typeIndex].EXPERTISE_ID
              );
            }
          }, this);
        } else {
          formData.append(
            "ID",
            this.documentConf.FILE_DOCUMENTS_PATH[
              this.docs[this.typeIndex].TYPE_ID
            ][0].ID
          );
          // formData.append(
          //   "EXPERTISE_ID",
          //   this.docs[this.typeIndex].EXPERTISE_ID
          // );
        }
      }
      formData.append("EXPERTISE_ID", this.docs[this.typeIndex].EXPERTISE_ID);
      formData.append("FILE", this.$refs.file.files[0]);
      formData.append("TYPE_ID", this.docs[this.typeIndex].TYPE_ID);
      formData.append(
        "UF_REPORT_TYPE_DOCUMENTS_ID",
        this.docs[this.typeIndex].UF_REPORT_TYPE_DOCUMENTS_ID
      );
      // formData.append(
      //   "ID",
      //   this.documentConf.FILE_DOCUMENTS_PATH[
      //     this.docs[this.typeIndex].TYPE_ID
      //   ][0].ID
      // );

      if (this.parent) {
        formData.append("FIELD_MODEL_ID", this.parent.FIELD_MODEL_ID);
        formData.append("RECORD_MODEL_ID", this.parent.RECORD_MODEL_ID);
      }

      if (this.docs[this.typeIndex].IS_ECP) {
        formData.append("UF_FILE_SIGN_ECP", this.ecpValue);
        formData.append("UF_FILE_SIGN_AUTHOR", this.ecpEnsurer);
      }

      ProjectsService.saveDocument(
        this.project.ID,
        formData,
        this.fileForm
      ).then(response => {
        console.log(response);
        if (!response.data.error) {
          this.updateDocInfo();
          this.showUploader = false;
          /*ProjectsService.getDocumentESProjects(this.$route.params.id).then(
            data => {
              this.documentConf.LIST_TYPE = data.LIST_TYPE;
              console.log("getDocumentESProjects: ", data);
              this.updateDocInfo();

              this.showUploader = false;
            },
            this
          );*/
        } else {
          this.errorArr = response.data.errorArr;
          this.uploadBlockButton = false;
        }
      }, this);
      return false;
    },
    changeFile() {
      let reader = new FileReader();
      this.ecpValue = "";
      this.ecpCert = "";
      (this.errorText = ""), reader.readAsDataURL(this.$refs.file.files[0]);
      reader.onload = () => {
        let file = this.$refs.file.files[0];
        if (file.size < 1024 * 1024 * 25) {
          let header = ";base64,";
          let fileData = reader.result;

          this.fileBase64 = fileData.substr(
            fileData.indexOf(header) + header.length
          );
        } else {
          this.errorText =
            "Загружаемый файл превышает максимально разрешенный размер. Загрузить можно файл размером не более 25 Мб";
        }
      };

      this.fileName = this.$refs.file.files[0].name;
      this.fileName2 = this.fileName;
      this.fileName = "    ";
    },
    stripTags(str) {
      str = str.toString();
      return str.replace(/<\/?[^>]+>/gi, "");
    }
  }
};
</script>

<style scoped></style>
